import Image from "next/image";

interface PageTitleHeaderProps {
  /** ページ最上部に表示するキャラクター画像。`public/` 配下のパスを渡す。 */
  imageSrc: string;
  /** 装飾扱いがデフォルト（WCAG H67）。スクリーンリーダーに読み上げたい場合のみ上書きする。 */
  imageAlt?: string;
  /** h1 文字列。 */
  title: string;
  /** タイトル下の補足。loading 等で動的に切り替える場合は呼び出し側で文字列を切り替える。 */
  subtitle: string;
  /**
   * 内側コンテナのクラス。ページ本体の `max-w-*` / 水平 padding と揃える。
   * 例: dashboard `max-w-7xl mx-auto px-5 md:px-10 py-6 md:py-10`、
   *     /practice/select `max-w-6xl mx-auto px-4 py-6 md:py-10`
   */
  containerClassName: string;
}

/**
 * ページ最上部に配置する全幅ストリップ型のタイトルヘッダー。
 * DESIGN.md §「ページタイトルヘッダー（共通）」準拠。
 *
 * 配置: ページの max-w-* コンテナ**外**に並列で置き、ストリップ自体は全幅展開する。
 * 内側のコンテンツは `containerClassName` で各ページのコンテンツ幅・水平 padding に揃える。
 */
export default function PageTitleHeader({
  imageSrc,
  imageAlt = "",
  title,
  subtitle,
  containerClassName,
}: PageTitleHeaderProps) {
  return (
    <div className="bg-surface shadow-[0_0_8px_rgba(44,26,30,0.08)]">
      <div className={containerClassName}>
        <div className="flex items-center">
          <Image
            src={imageSrc}
            alt={imageAlt}
            width={64}
            height={64}
            className="w-14 h-14 md:w-16 md:h-16 shrink-0 mr-4"
            priority
          />
          <div>
            <h1 className="text-2xl md:text-3xl font-bold leading-tight">
              {title}
            </h1>
            <p className="text-sm md:text-xl mt-1">{subtitle}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
